import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { CSSTransition } from "react-transition-group";

//Package CSS
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "animate.css/animate.min.css";

//Template CSS Style
import "../src/style.css";
import "./assets/css/responsive.css";
import "./assets/css/color/color-hkg.css";

//Import Component
import Home from "./pages/Home";
import ScrollUpBtn from "./components/ScrollUp";
import Success from './pages/Success';
import Canceled from './pages/Canceled';

class App extends Component {
    render() {
        return (
            <div className="App">
                <div>
                    <Route
                        render={({ location }) => (
                            <CSSTransition
                                key={location.key}
                                timeout={{ enter: 900, exit: 900 }}
                                classNames="fade"
                            >
                                <section className="route-section">
                                    <Switch location={location}>
                                        <Route
                                            path="/success"
                                            component={Success}
                                        />
                                        <Route
                                            path="/canceled"
                                            component={Canceled}
                                        />
                                        <Route
                                            path="/"
                                            component={Home}
                                        />
                                        <Redirect to="/error" />
                                    </Switch>
                                </section>
                            </CSSTransition>
                        )}
                    />
                    {/* ScrollUpBtn: src/components/ScrollUp.jsx */}
                    <ScrollUpBtn />
                </div>
            </div>
        );
    }
}
export default App;
